import PropTypes from 'prop-types';
import React from 'react';
import Browser from '@wetransfer/concorde-browser';

import Icon from '@component/icon';

import { WOODSMOKE } from '@constant/colors';

function makeItems(items, props) {
  return items.map((item) => {
    if (item.hidden) {
      return;
    }

    const active = item.href === props.activeItem;
    const className = ['verticalnav__item'];
    let arrow = null;
    let anchors = null;
    let rel = null;

    if (active) {
      className.push('verticalnav__item--active');
      arrow = !Browser.isMobile ? (
        <span key={item.href} className="verticalnav__arrow">
          <Icon type="Arrow" color={WOODSMOKE} />
        </span>
      ) : null;

      if (item.anchors) {
        className.push('verticalnav__item--has-subitems');
        anchors = (
          <ul className="verticalnav__list">
            {makeItems(item.anchors, props)}
          </ul>
        );
      }
    }

    if (item.external) {
      className.push('verticalnav__item--is-external');
      rel = 'external';
    }

    // Not sure whether we should real anchors or onClick events for this
    let label = null;
    if (item.href) {
      label = (
        <a href={item.href} rel={rel}>
          {item.label}
        </a>
      );
    } else {
      label = <p>{item.label}</p>;
      className.push('verticalnav__item--is-only-label');
    }

    if (item.className) {
      className.push(item.className);
    }

    return (
      <li
        key={item.href || item.label}
        className={className.join(' ')}
        onClick={props.onClick ? () => props.onClick(item.href) : null}
      >
        {arrow}
        {label}
        {item.icon}
        {anchors}
      </li>
    );
  });
}

const VerticalNav = (props) => {
  const className = ['verticalnav'];

  if (props.className) {
    className.push(props.className);
  }

  if (props.sticky) {
    className.push('verticalnav--is-sticky');
  }

  return (
    <nav className={className.join(' ')}>
      <ul className="verticalnav__list">{makeItems(props.items, props)}</ul>
      {props.children}
    </nav>
  );
};

VerticalNav.propTypes = {
  items: PropTypes.array,
  className: PropTypes.string,
  activeItem: PropTypes.string,
  onClick: PropTypes.func,
  sticky: PropTypes.bool,
  children: PropTypes.any,
};

VerticalNav.defaultProps = {
  className: null,
  sticky: false,
};

export default VerticalNav;
